define('shared/initializer/form/newHouseAdapters/mixins/CreditCardUpdatable',[
    'shared/lib/RSVP',
    'shared/remote/payment/creditCard/update',
    './CreditCardPayable'
], 
function(
    RSVP,
    updateCreditCard,
    CreditCardPayable
) {
    function Ctor() {}

    Ctor.prototype.doSubmit = function() {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                return updateCreditCard(
                    CreditCardPayable.getCreditCardOptions(me.$form)
                );
            });
    };

    return Ctor;
});
